import { Download } from "lucide-mui";
import Button from "@mui/material/Button";
import { useState } from "react";
import type { FilterOption } from "../../../components/ChipAutocomplete.tsx";
import ExportFieldsDialog from "../../../components/ExportFieldsDialog.tsx";

interface ExportButtonProps {
  total: number;
  contactRoleTypeOptions: FilterOption[];
  onExport: (fields: string[], roleColumns: string[]) => Promise<void>;
}

export default function ExportButton({
  total,
  contactRoleTypeOptions,
  onExport,
}: ExportButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Download />}
        onClick={() => setOpen(true)}
      >
        {`Export to CSV${total > 100_000 ? " (max 100k)" : ""}`}
      </Button>
      {open && (
        <ExportFieldsDialog
          onClose={() => setOpen(false)}
          storageKey="export-fields-master-companies"
          roleTypes={contactRoleTypeOptions}
          onExport={onExport}
        />
      )}
    </>
  );
}
